import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // If returning from Emergent OAuth, let AuthCallback handle first
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginRespondent = async (email, password) => {
    const res = await api.post("/auth/respondent/login", { email, password });
    localStorage.setItem("mano_jwt", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const registerRespondent = async (payload) => {
    const res = await api.post("/auth/respondent/register", payload);
    localStorage.setItem("mano_jwt", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    localStorage.removeItem("mano_jwt");
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
  };

  const setUserAfterOAuth = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, loginRespondent, registerRespondent, logout, setUserAfterOAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
